import React from "react";
import { JobDescriptionEntity } from "../../../../Entities/JobDescription";
import { InterviewRound } from "../../../../Dto/GenerateJobDescription.dto";
import InsightsDashboard from "./insights";

interface DetailsProps {
  jobPost: JobDescriptionEntity | null;
  interviewRoundDetails: InterviewRound[];
}

const Details: React.FC<DetailsProps> = ({
  jobPost,
  interviewRoundDetails,
}) => {
  return (
    <InsightsDashboard
      jobPost={jobPost}
      interviewRoundDetails={interviewRoundDetails}
    />
  );
};

export default Details;
